@if (otherDocumentsForm) {
  <div [formGroup]="otherDocumentsForm">
    <div class="mb-3">
      <small
        ><strong
        >Nous vous remercions de poster ici des documents complémentaires à l’instruction du dossier, en lien avec les demandes de la DIE lors
        d’informations nécessaires. <br />Si aucun document complémentaire ne vous est demandé, merci de ne rien ajouter ici.</strong
        ></small
        >
      </div>
      <div formArrayName="otherDocuments">
        @for (otherDocument of otherDocuments.controls; track otherDocument; let i = $index) {
          <div class="row mb-2" [formGroupName]="i">
            <div class="col-12 col-lg-6 mb-2">
              <app-file-input
                formControlName="document"
                [beneficiary]="beneficiary"
            [invalid]="
              $any(otherDocuments.controls[i])?.controls?.document?.errors?.fileSize ||
              $any(otherDocuments.controls[i])?.controls?.document?.errors?.fileType ||
              (submitted && $any(otherDocuments.controls[i])?.controls?.document?.errors)
            "
                title="autre"
                [titleId]="40"
                accept="application/pdf,image/png,image/jpeg"
                [maxFileSize]="maxFileSize"
              ></app-file-input>
            </div>
            <div class="col-12 col-lg-6 mb-lg-2">
              <div class="input-group">
                <input type="text" class="form-control rounded" formControlName="comment" placeholder="Commentaire ..." />
                <button
                  type="button"
                  class="btn btn-outline-primary ms-3 rounded"
                  ngbTooltip="Supprimer"
                  placement="left"
                  (click)="removeDocument(i)"
                  [disabled]="disabled"
                  >
                  <fa-icon icon="trash-alt"></fa-icon>
                </button>
                <button
                  type="button"
                  class="btn btn-primary ms-3 rounded"
                  ngbTooltip="Ajouter"
                  placement="left"
                  (click)="addNewDocument()"
                  [disabled]="disabled"
                  [class.invisible]="i > 0"
                  >
                  <fa-icon icon="plus"></fa-icon>
                </button>
              </div>
            </div>
            @if (otherDocuments.at(i)?.value?.errors?.fileSize) {
              <small class="form-text text-danger ms-3">
                Le document ne doit pas dépasser {{ maxFileSizeStr }}.
              </small>
            }
            @if (otherDocuments.at(i)?.value?.errors?.fileType) {
              <small class="form-text text-danger ms-3"
                >Le document doit être de type PDF, PNG ou JPG.</small
                >
              }
            </div>
          }
        </div>
      </div>
    }
